module.exports = __webpack_public_path__ + "static/media/13_tn.fdb41e2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/13_tn.jpg
// module id = 227
// module chunks = 0